var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { Colors } from '../../constants';
import { fontSizes } from './fontSizes';
var weightCss = function (weight) {
    if (weight === void 0) { weight = 'medium'; }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function () {
        switch (weight) {
            case 'thin':
                return '200';
            case 'regular':
                return '300';
            case 'medium':
                return '400';
            case 'semi-bold':
                return '600';
            case 'bold':
                return '700';
            case 'heavy':
                return '900';
            default:
                return '400';
        }
    });
};
export var combinedCss = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'm' : _b, _c = _a.weight, weight = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? 'WHITE' : _d, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'Matter' : _e, center = _a.center;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: 24px;\n  ", "}\n"], ["\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: 24px;\n  ", "}\n"])), color ? Colors[color] : Colors.WHITE, fontFamily, fontSizes[size], weightCss(weight), center ? 'text-align: center;' : '');
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map